
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/partners/[partner]/digital-access-program",
      function () {
        return require("private-next-pages/partners/[partner]/digital-access-program.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/partners/[partner]/digital-access-program"])
      });
    }
  